import React, { useState } from 'react';
import PaginationSection from '../../../../shared/PaginationSection';
import ClaimRewardsModal from '../modals/ClaimRewardsModal';
import WithdrawBondModal from '../modals/WithdrawBondModal';
import ChildPoolTableRow from './ChildPoolTableRow';
import ChildPoolMobileCard from './ChildPoolMobileCard';

function ChildPools({
    childPools,
    currentPage,
    perPage,
    totalItems,
    onPageChange,
    onPerPageChange,
    setDummyData
}) {
    const [showClaimRewards, setShowClaimRewards] = useState(false);
    const [showWithdrawBond, setShowWithdrawBond] = useState(false);
    const [selectedPoolData, setSelectedPoolData] = useState(null);

    // console.log(childPools, "childPools");

    const handleClaimRewards = (pool) => {
        setSelectedPoolData(pool);
        setShowClaimRewards(true);
    };

    const handleWithdrawBond = (pool) => {
        setSelectedPoolData(pool);
        setShowWithdrawBond(true);
    };

    const handleCloseClaimRewards = () => {
        setShowClaimRewards(false);
        setSelectedPoolData(null);
    };

    const handleCloseWithdrawBond = () => {
        setShowWithdrawBond(false);
        setSelectedPoolData(null);
    };

    return (
        <>
            <div
                className="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
            >
                {/* Desktop View */}
                <div className="table_main d-none d-lg-block">
                    <div className="table_innner">
                        <p className="one_sidee">#</p>
                        <p className="poolname">Root Pool</p>
                        <p>APY</p>
                        <p>TVL</p>
                        <p>Staking Amount</p>
                        <p>Creator Fee%</p>
                        <p>Stakers Count</p>
                        <p>Status</p>
                        <p></p>
                    </div>

                    {childPools && childPools.length > 0 ? (
                        childPools.map((pool, index) => (
                            <ChildPoolTableRow
                                key={pool.id}
                                pool={pool}
                                index={index}
                                onClaimRewards={handleClaimRewards}
                                onWithdrawBond={handleWithdrawBond}
                            />
                        ))
                    ) : (
                        <div className="no-data">
                            <p>No child pools available</p>
                        </div>
                    )}

                    <PaginationSection
                        currentPage={currentPage}
                        totalItems={totalItems}
                        perPage={perPage}
                        onPageChange={onPageChange}
                        onPerPageChange={onPerPageChange}
                    />
                </div>

                {/* Mobile View */}
                <div className="formobile d-block d-lg-none">
                    <div className="mobilebox">
                        {childPools && childPools.length > 0 ? (
                            childPools.map((pool, index) => (
                                <ChildPoolMobileCard
                                    key={pool.id}
                                    pool={pool}
                                    index={index}
                                    onClaimRewards={handleClaimRewards}
                                    onWithdrawBond={handleWithdrawBond}
                                />
                            ))
                        ) : (
                            <div className="no-data">
                                <p>No child pools available</p>
                            </div>
                        )}

                        {/* Mobile Pagination */}
                        <PaginationSection
                            currentPage={currentPage}
                            totalItems={totalItems}
                            perPage={perPage}
                            onPageChange={onPageChange}
                            onPerPageChange={onPerPageChange}
                        />
                    </div>
                </div>
            </div>

            {/* Modals */}
            <ClaimRewardsModal
                show={showClaimRewards}
                onHide={handleCloseClaimRewards}
                poolData={selectedPoolData}
                setDummyData={setDummyData}
            />

            <WithdrawBondModal
                show={showWithdrawBond}
                onHide={handleCloseWithdrawBond}
                poolData={selectedPoolData}
            />
        </>
    );
}

export default ChildPools;